import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';
import { PaymentFormComponent } from '../../payment/payment-form/payment-form.component';

import { IBillingInfo } from 'app/interfaces/profile.interfaces';
import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';

import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EPaymentType } from 'app/enums/payments.enums';

@Component({
  selector: 'stxt-billing-info',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, PaymentFormComponent],
  templateUrl: './billing-info.component.html',
  styleUrl: './billing-info.component.scss'
})
export class BillingInfoComponent {
  @Input() billingInfo: IBillingInfo[];
  @Output() billingMethodAdded: EventEmitter<string> = new EventEmitter<string>();

  public editMode: boolean = false;
  public readonly EPaymentType = EPaymentType;
  public infoSvgConfig: ISvgConfig = { name: 'info', fill: ESvgTypes.None };
  public editBillingMethodSvg: ISvgConfig = { fill: ESvgTypes.None, name: 'pen' };
  public oldPaymentMethodId: string;

  handleUpdateBilling(): void {
    this.billingMethodAdded.emit('success');
    this.editMode = false;
  }

  editBillingMethod(id: string): void {
    this.oldPaymentMethodId = id;
    this.editMode = true;

    // Leaving this here in case if we need to delete payment method.
    // this.profileService
    //   .removeBillingInfo(id)
    //   .pipe(first())
    //   .subscribe({
    //     next: () => {
    //       this.billingInfo = this.billingInfo.filter((method: IBillingInfo) => method.id !== id);
    //     },
    //     error: err => {
    //       if (err.status == 200) {
    //         //TODO: Handle error if any
    //         this.billingInfo = this.billingInfo.filter((method: IBillingInfo) => method.id !== id);
    //       }
    //     }
    //   });
  }
}
